import { useFlowContainerContext } from '@/contexts/FlowContext'

import { FlowConfigureModal } from './FlowConfigure'
import { FlowHistoryModal } from './FlowHistory'
import { FlowRunningModal } from './FlowRunning'
import { FlowTestModal } from './FlowTest'
import { NodeConfigureModal } from './NodeConfigureModal'
import { NodeResultModal } from './NodeResult'

interface FlowModalManagerProps {
    rootRef: HTMLDivElement
}

export const FlowModalManager = () => {
    const { modalState } = useFlowContainerContext()

    switch (modalState.type) {
        case 'FLOW_CONFIGURE': {
            return <FlowConfigureModal />
        }
        case 'FLOW_RUNNING_HISTORY': {
            return <FlowHistoryModal />
        }
        case 'FLOW_RUNNING_START_TEST': {
            return <FlowTestModal />
        }
        case 'FLOW_RUNNING_RESULT': {
            return <FlowRunningModal />
        }
        case 'NODE_CONFIGURE': {
            return <NodeConfigureModal />
        }

        case 'NODE_RUNNING_RESULT': {
            return <NodeResultModal />
        }

        default: {
            return null
        }
    }
}
